/**
 * Home — the homepage at `/`.
 *
 * Composition:
 *   - Global site Navbar (sticky at top)
 *   - LandingHero (the hand-built design from `trex-hero_29.html`, injected
 *     into the React DOM with its CSS scoped to `.trex-hero-host`)
 *   - Global site Footer
 *
 * No iframe, no fixed positioning. The page scrolls natively, the iframe
 * paint-throttling blank-flash is gone, IntersectionObservers in the
 * LandingHero script fire on the main window scroll the same way they did
 * inside the iframe, and the Footer can flow underneath naturally.
 */
import { Helmet } from "react-helmet-async";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { LandingHero } from "../components/LandingHero";

export default function Home() {
  return (
    <main className="min-h-screen bg-aubergine" data-testid="home-page">
      <Helmet>
        <title>T-REX Network | The utility network for tokenized securities</title>
      </Helmet>
      <Navbar />
      {/* Spacer to clear the fixed Navbar so LandingHero's hero begins below it. */}
      <div aria-hidden="true" style={{ height: 64 }} />
      <LandingHero />
      <Footer />
    </main>
  );
}
